<div class="container-fluid widget-wrapper">
  <div class="row widget-header" #widgetHeader [ngClass]="{ sticky: isTop }">
    <div class="col-lg-12">
      <h2>
        <span>Estimated Inventory</span><span class="app-title">&nbsp;{{ appName | appPrefix }}</span>
        <a class="btn btn-link help-icon" data-placement="top" data-toggle="tooltip" enTooltip title="The estimated volume of ad impressions offered by the app over programmatic advertising platforms and exchanges.">
          <img src="/assets/images/icon-indicator-info.svg" alt="Info Icon"/>
        </a>
        <ng-container *ngTemplateOutlet="swiperControls"></ng-container>
      </h2>
    </div>
  </div>
  <div class="row widget-body">
    <div class="col-lg-12">
      <app-inventory [data]="data" [region]="region" [isFollowing]="isFollowing" [isFreemium]="isFreemium"
                     (anchorClick)="anchorClick.emit($event)"></app-inventory>
    </div>
  </div>
</div>
